import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { useTrackEvent } from "lib/mixpanel"
import { TRACKING_EVENTS } from "lopermut"
import { CampaignResponseDataSchema } from "schema"
import { z } from "zod"
import { getCampaignQueryKey } from "../lib/campaignQuery"

export const useCreateCampaignMutation = () => {
  const queryClient = useQueryClient()
  const trackEvent = useTrackEvent()

  return useMutation({
    mutationFn: async () => {
      const { data } = await axios.post<{ data: z.infer<typeof CampaignResponseDataSchema> }>(
        "/campaigns",
      )

      trackEvent(TRACKING_EVENTS.CAMPAIGN_CREATED, {
        campaignId: data.data.id,
        campaignName: data.data.name,
        campaignTrigger: data.data.trigger,
        campaignStatus: data.data.status,
        campaignChannel: data.data.channel,
      })

      return data.data
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: getCampaignQueryKey(data.id) })
    },
  })
}
